import BaseObject from './BaseObject';
import {Material, Matrix4, Mesh} from 'three';
import {MaterialTypes, ObjectTypes, PonticObjectDescription} from '@data/models';
import { GeometryProvider, MaterialsProvider } from '@data/providers';
import { WebGLScene } from '../WebGLScene';
import {Dictionary} from '@types';
import ToothObject from '@view/widgets/Scene/WebGLScene/objects/ToothObject';


class PonticObject extends BaseObject {
  private _originalMaterial: THREE.Material | THREE.Material[];
  private _semitransparentMaterial: THREE.Material | THREE.Material[];
  constructor(mesh: Mesh) {
    super(mesh, ObjectTypes.Pontic);
    this._originalMaterial = mesh.material;
    this._semitransparentMaterial = (this._originalMaterial as Material).clone();
    this._semitransparentMaterial.transparent = true;
    this._semitransparentMaterial.opacity = 0.5;
    this._semitransparentMaterial.needsUpdate = true;
  }

  static async create(
    description: PonticObjectDescription,
    scene: WebGLScene,
    geometryProvider: GeometryProvider,
    materialsProvider: MaterialsProvider
  ) {
    const mesh = new Mesh(
      geometryProvider.getGeometryByDescription(description),
      materialsProvider.getMaterial(MaterialTypes.Pontic, undefined, description.jaw)
    );

    const position = mesh.position.clone();
    const rotation = mesh.rotation.clone();
    const scale = mesh.scale.clone();

    if (description.transform) {
      const matrix = new Matrix4();
      matrix.fromArray(description.transform);
      matrix.transpose();
      mesh.applyMatrix4(matrix);
    }

    ToothObject.updateOcclusions(mesh as Mesh, description);

    const obj = new PonticObject(mesh);
    obj.setInitial(position, rotation, scale);
    // obj.addToScene(scene);
    scene.getRootObject().add(obj.mesh);

    obj.id = description.id;
    obj.visible = description.visible;

    return obj;
  }

  async update (description: PonticObjectDescription, objects: Dictionary<BaseObject>) {
    await super.update(description, objects);
    const mesh = this._mesh as Mesh;
    ToothObject.updateOcclusions(mesh, description);
    ToothObject.updateSemitransparency(mesh, description.isSemitransparent);
  }
}

export default PonticObject;
